import { ajvForModels } from "@fieldday/fielddayportal-model";

const ajv = ajvForModels

export default ajv
